module.exports = __webpack_public_path__ + "img/no_course.884c800a.png";